/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate")

package js.features.userRegistration

import kangaroorewards.appsdk.core.api.Api
import kangaroorewards.appsdk.core.domain.SerializedResult
import kangaroorewards.appsdk.core.domain.toJsonResult
import kotlinx.coroutines.DelicateCoroutinesApi
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.promise
import kotlin.js.Promise
import kotlinx.serialization.json.Json
import features.userRegistration.UserRegistrationApi
import features.userRegistration.models.UserProfileDataModel
import features.userRegistration.serializeUserRegistrationState



/**
 * Register a new user. Either a phone number or an email address is required. [Api] class
 */
@OptIn(DelicateCoroutinesApi::class)
@ExperimentalJsExport
@JsExport
@JsName("UserRegistrationApi")
class UserRegistrationApiJs {

    /**
     * Register a new user. Either a phone number or an email address is required.
     */
    fun createAccount(
        overrideHeaders: String?, 
        email: String? = null,
        phone: String? = null,
        countryCode: String? = null,
        language: String? = null
    ): Promise<String?>  {
        return GlobalScope.promise {

        val decodedOverrideHeaders = if (overrideHeaders == null) {
                null
        } else {
            try {
                Json.decodeFromString<Map<String, String>>(overrideHeaders)
            } catch (e: Exception) {
                null
                }
            }

            val result = UserRegistrationApi().createAccount(
            overrideHeaders = decodedOverrideHeaders,
                        email = email,
            phone = phone,
            countryCode = countryCode,
            language = language
        ).toJsonResult<UserProfileDataModel>()
        
            return@promise when (result) {
                is SerializedResult.Success -> result.data
                is SerializedResult.UnauthorizedError -> result.error
                is SerializedResult.UnknownError -> result.error
                else -> null
            }
        }
    }

    

    

    fun observeUserRegistrationState(
        onData: (String) -> Unit,
        onStreamError: (String) -> Unit,
    ) {
        UserRegistrationApi().userRegistrationState.serializeUserRegistrationState().observe { result ->
            when (result) {
                is SerializedResult.Idle -> onData(result.state)
                is SerializedResult.Loading -> onData(result.state)
                is SerializedResult.Success -> onData(result.data)
                is SerializedResult.UnauthorizedError -> onData(result.error)
                is SerializedResult.UnknownError -> onData(result.error)
                else -> onStreamError("unknown error in stream")
            }
        }
    }
}
